import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import NewNotice from "../components/notices/NewNotice";
import { ICooperative } from "../exports/interfaces";
import { useUser } from "../context/UserContext";
import { fetchCooperative } from "../api/DashboardApi";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed } from "../hooks/useToast";

const CreateNoticesPage = () => {
  const { setLoading } = useLoader();
  const [cooperative, setCooperative] = useState<ICooperative[]>([]);
  const { user } = useUser();
  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchCooperative()])
      .then(([cooperativeData]) => {
        setCooperative(cooperativeData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading, user]);
  return (
    <>
      <PageLayout>
        <SearchHeader />
        <div className="inner-main-content">
          <NewNotice cooperative={cooperative} />
        </div>
      </PageLayout>
    </>
  );
};

export default CreateNoticesPage;
